import { useState, useContext, useEffect } from 'react';
import { FieldValues, useForm } from 'react-hook-form';

import { AuthContext } from 'contexts/AuthContext';

const useLoginForm = () => {
  const { handleSubmit, register } = useForm();
  const authContext = useContext(AuthContext);
  const [error, errorSet] = useState('');
  const isNewPasswordSet = authContext?.isNewPassword;

  const onSubmit = async (data: FieldValues) => {
    try {
      await authContext.signInWithEmail(data.email, data.password);
      // eslint-disable-next-line
    } catch (err: any) {
      errorSet(err.message);
    }
  };

  useEffect(() => () => authContext && authContext.isNewPasswordSet(false));

  return {
    handleSubmit,
    register,
    error,
    onSubmit,
    isNewPasswordSet,
  };
};

export { useLoginForm };
